import { Injectable } from "@angular/core";
import { PlanData } from "../plans/plan-data";
import { SessionSteps } from "./sessionSteps";

import { Booking } from 'src/providers/booking/booking';
import { Client } from 'src/providers/client/client';
import { Me } from "../me/me";
import { AddressesQueriesService } from 'src/shared/services/addresses-queries.service';

@Injectable()
export class AfterLoginRedirect {
  addressesList: any;
  redirectTo: { name?: string, data?: any } | null = null;
  // The booking a signed-out customer opened from a job link, opened again once they sign in.
  pendingBookingId: string | null = null;

  constructor(
    private addressesQueries: AddressesQueriesService,
    private booking: Booking,
    private client: Client,
    private planData: PlanData,
    private sessionSteps: SessionSteps,
    private me: Me
  ) {}

  async getTarget(bookingId = null) {
    if (this.redirectTo) {
      const notificationRedirect = this.redirectTo;
      this.redirectTo = null;

      return notificationRedirect;
    }

    const accType = await this.me.getAccType();
    if (accType === 'employer') {
      return { page: 'employer-dashboard/employer-dashboard' };
    }
    const userRole = localStorage.getItem('user_role');
    if (userRole === 'member') {
      return { page: 'properties' };
    }
    try {
      const billingData = await this.client.getBillingData();
      const creditBalance = billingData?.balance;
      const employerName = billingData?.balance_details[0]?.transferred_from?.account_name;
      localStorage.setItem('creditBalance', creditBalance.toString());
      localStorage.setItem('employerName', employerName);
      if (employerName && employerName !== 'undefined') {
        const addressResponse = await this.addressesQueries.getAddresses();
        const address = addressResponse[0];
        if (!address) {
          return { page: 'add-first-property/employee' };
        }
        // Employer-credit clients with no bookings yet used to land on the legacy
        // get-started page. That path now resolves to the RENTAL onboarding wizard
        // (which pitches an account manager), so everyone with an address goes to
        // Overview — don't reintroduce a get-started redirect here.
        return { page: 'properties' };
      }
    } catch(_err) {
      // Silent error handling - fallback to default navigation
    }
    this.addressesList = await this.addressesQueries.getAddresses();
    return this.process(this.addressesList, bookingId, accType)
  }

  async process(addresses, bookingId, accType) {
    if (addresses.length === 0) {
      return {
        page: this.client.getAddFirstAddressRedirectPage(accType),
        data: {
          hasNoAddresses: true
      }
      };
    }
    if (bookingId) {
      const path = await this.booking.getBookingPath(bookingId);
      return { page: path };
    }
    localStorage.setItem('addressId', this.addressesList[0].id);
    if (this.addressesList?.length === 1 && accType !== 'rental') {
      return { page: 'schedule' };
    } else {
      return { page: 'properties' };
    }
  }

}
